module.exports = __webpack_public_path__ + "static/media/magneti-za-rodjendane.1c1ccfd7.png";